import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `PUT /client/:cid/users/:id/password {password}`: 403 when the login also belongs to another client. */
export const editUserPassword = async (user_id: string, password: string): Promise<any> => {
  await lpRequest('PUT', clientPath(`/users/${user_id}/password`), { body: { password } });

  return getUser(user_id);
};
